import { Button } from "primereact/button";

const taskQuestions = [
  {
    id: 1,
    taskName: "To start, tell us your first name and where you live.",
    instructions: "Please explain verbally",
  },
  {
    id: 2,
    taskName: "To start, tell us your first name and where you live.",
    instructions: "Please explain verbally",
  },
  {
    id: 2,
    taskName: "To start, tell us your first name and where you live.",
    instructions: "Please explain verbally",
  },
];

const AllTaskQuestionViewComponent = ({ allTQToggle, handleAllTQToggle }) => {
  return (
    <div className="pb-2 all-task-question-wrapper">
      {!allTQToggle ? (
        <div className="question-wrapper p-2 toggle">
          <h5>1. To start, tell us your first name and where you live.</h5>
          <p className="text-muted mb-2 instructions-content">
            <em>Instructions:</em> Please explain verbally
          </p>
        </div>
      ) : (
        <div className="all-task-questions">
          <h5 className="text-center p-2 mb-0 fw-bold tqheadTitle">
            TASK/QUESTIONS
          </h5>
          <div className="tq-list">
            {taskQuestions?.length
              ? taskQuestions?.map((taskQuestion, index) => (
                  <div className="p-2" key={index}>
                    <h5>
                      <span>{index + 1}.</span> {taskQuestion?.taskName}
                    </h5>
                    <p className="text-muted mb-2">
                      <em>Instructions:</em> {taskQuestion?.instructions}
                    </p>
                  </div>
                ))
              : ""}
          </div>
        </div>
      )}
      <div className="d-flex justify-content-center mt-2">
        <Button
          className="createClientBtn"
          onClick={() => handleAllTQToggle(!allTQToggle)}
        >
          All Tasks/Questions{" "}
          <i
            className={`ms-1 pi ${!allTQToggle ? "pi-chevron-up" : "pi-chevron-down"}`}
          ></i>
        </Button>
      </div>
    </div>
  );
};

export default AllTaskQuestionViewComponent;
